<template>
  <el-dialog  :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose" v-loading="loading">
    <div class="dialogData">
      <!-- <div>Check result: <span :class="viewList.OrderCheckStatus!=0?'text_greed':'text_red'">{{viewList.OrderCheckStatus!=0?'OK':'something wrong'}}</span>
      </div> -->
      <div>{{$t('alert.CheckingWarn')}}</div>
      <div class="pay_fee_box" v-if="viewList.PayPostageMoney&&viewList.PayPostageMoney>0">{{$t('colon.shippingFeePaid')}} <span class="text_blue">{{$t('base.about')}} {{areaSymbol}} {{viewList.PayPostageMoney.toFixed(2)}}</span>
      <div class="view_title">({{$t('alert.overseasGoodTip')}})</div>
      </div>
      <div class="view_data">
        <div class="eval_data" v-for="(item,index) in viewList.data" :key='index'>
          <el-image class="like_img" :src="item.ImgUrl!='没有可上传的图片'?item.ImgUrl+'?imageView2/2/w/200':'../static/images/noimg.svg'"
              fit="contain" lazy :preview-src-list="[item.ImgUrl]">
          </el-image>
          <p>{{item.Describe}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <el-button @click="toSafeguard" v-if="list.SellerWyAccId!=3">
          {{list.SRType==0?$t('base.openCase'):$t('base.viewCaseDetail')}}
        </el-button>
        <el-button type="primary" @click="receive">{{$t('base.confirm')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      loading:false,
    }
  },
  props: {
    dialogClass:'',
    title: "",
    domVisible: Boolean,
    list: {},
    viewList:{},
    userInfo: {}
  },
  watch: {},
  filters: {},
  mounted(){
    this.$root.$on("confirmLoading", val => {
      //console.log("newSearch", val)
      this.loading = val;
    })
  },
  created() {
    this.areaSymbol=this.list.RealLowestPriceUnit
  },
  methods: {
    handleClose(){
      this.$emit('closeDialog','confirm', false)
    },
    toSafeguard(){
      this.$emit('closeDialog','confirm', false)
      this.$emit('dialog',this.list,'safeguard')
    },
    receive(){
      this.$emit('SetReceive',this.viewList,0)
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";
</style>



// WEBPACK FOOTER //
// src/components/dialog/confirm.vue